import { Button, Modal, Typography, Box, Divider } from "@mui/material";
import styles from "./ConfirmationModal.module.scss";
import { useTranslation } from "react-i18next";
import { TiTick } from "react-icons/ti";
import { AiFillCheckCircle } from "react-icons/ai";
import { FaExclamationTriangle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { BsExclamationCircleFill } from "react-icons/bs";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",

  pt: 2,
  px: 4,
  pb: 3,
};
const ModalExpired = (props) => {
  const { open, handleClose, eventId } = props;
  const navigate = useNavigate();
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <Box sx={{ ...style, width: "fit-content", borderRadius: 3 }}>
        <Box className={styles.allertImg}>
          <BsExclamationCircleFill size={30} color="#FFCC00" />
        </Box>
        <Box sx={{ textAlign: "center", marginBottom: 1 }}>
          <Typography fontWeight={700} fontSize={20}>
            Your Session has expired
          </Typography>
        </Box>
        <Box maxWidth={"280px"}>
          <Typography textAlign={"center"} fontWeight={600}>
            Your session has expired, please start a new payment
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: 1,
            justifyContent: "center",
            marginTop: 2,
          }}
        >
          <Button
            variant="outlined"
            onClick={() => {
              navigate(`../../${eventId}`, { replace: true });
            }}
          >
            Go Back To Main Page
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalExpired;
